export const SOLD_SUBSCRIPTION_PAYMENT_TYPE = {
    MANUAL: 'manual',
    IBAN: 'iban',
    FIRST_PAYMENT: 'first_payment',
    AUTOMATIC: 'automatic',
};
